$(document).on('click', '.dropdown-menu .dropdown-item.financial-year', function(event) {
  event.preventDefault();
  const url = $(this).attr('href');

  $.ajax({
    url: url,
    type: 'GET',
    dataType: 'json',
    success: function(response) {
      const repaymentPrognosis = response.financial_dashboard.repayments;
      const translations = response.translations;
      updateExpectedRepayments(repaymentPrognosis, translations);
    },
    error: function(xhr, status, error) {
      console.error('AJAX Error:', status, error);
    }
  })
});

function updateExpectedRepayments(repaymentPrognosis, translations) {
  const container = $("[data-type~=expected-repayments-by-month]");
  if (container.length === 0) {
    console.error("Target container not found.");
    return;
  }

  // Create the new HTML structure dynamically
  let html = `
    <canvas class="mb-4" data-behavior="stacked-bar-chart"
      data-sets='${JSON.stringify(repaymentPrognosis)}'
      data-keys='["notional", "interest"]'
      data-names='{"interest": ${translations.interest_repayment_header}, "notional": ${translations.notional_repayment_header}}'
      data-label="date">
    </canvas>
    
    <div class="table-responsive">
      <table class="table table-striped table-borderless mb-5">
        <thead>
          <tr>
            <th>${translations.date_header}</th>
            <th>${translations.notional_repayment_header}</th>
            <th>${translations.interest_repayment_header}</th>
            <th>${translations.total_repayment_header}</th>
          </tr>
        </thead>
        <tbody>
  `;

  // Add repayment rows
  repaymentPrognosis.forEach(repayment => {
    html += `
      <tr>
        <td>${new Date(repayment.date).toLocaleDateString()}</td>
        <td>${repayment.notional} €</td>
        <td>${repayment.interest} €</td>
        <td>${repayment.total} €</td>
      </tr>
    `;
  });

  html += `
        </tbody>
      </table>
    </div>
  `;

  // Inject the new HTML into the page
  container.html(html);

  // Reinitialize JavaScript behaviors if needed
  if (typeof $.onmount === "function") {
    $.onmount();
  }
}
